import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const axios = createApiFor(`/${Config.general.basestore}/stock`, { bff: true });

export const useBFFStockService = () => axios;

export const useBFFStockServiceApi = makeUseAxios({
    axios: axios,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;
